export const selectIsSMSEnabled  = state => {
  return state.OrganisationReducer.customerData.isSMSEnabled;
}

export const getUserNotifySetting = state => {
  return state.OrganisationReducer.customerData.userNotifySetting;
}

export const getUserInventMsgCustomize  = state => {
  return state.OrganisationReducer.customerData.userInventMsgCustomize;
}

export const getIsEntryAllowed = state => {
  return state.OrganisationReducer.customerData.isEntryAllowed;
}

export const getIsReductionLogs  = state => {
  return state.OrganisationReducer.customerData.isReductionLogs
}

export const getHorizontalDisplayFixed = state => {
  return state.OrganisationReducer.customerData.horizontalDisplayFixed;
}

export const getDisableCanvasEdit = state => {
  return state.OrganisationReducer.customerData.disableCanvasEdit;
}

export const getDisableIcsFile = state => {
  return state.OrganisationReducer.customerData.disableIcsFile;
}

export const getDisableInitiatingCoBrowse = state => {
  return state.OrganisationReducer.customerData.disableInitiatingCoBrowse;
}

export const getDisableCanvasDownload = state => {
  return state.OrganisationReducer.customerData.disableCanvasDownload;
}

export const getCustomerName = state => {
  return state.OrganisationReducer.customerData.name;
}

export const getCustomerUriIdentifier = state => {
  return state.OrganisationReducer.customerData.uri_identifier;
}

export const getOperatorExclusiveRecordingControl = state => {
  return state.OrganisationReducer.customerData.operatorExclusiveRecordingControl;
}

export const getRingtoneLoopEnabled = state => {
  return state.OrganisationReducer.customerData.ringtoneLoopEnabled;
}

export const getWording = state => {
  return state.OrganisationReducer.customerData.wording;
}

export const getTranslation = state => {
  return state.OrganisationReducer.customerData.translation;
}

export const getWordingFileUrl = state => {
  return state.OrganisationReducer.wordingUrl;
}

export const getIsWordingFileUrlFetched = state => {
  return state.OrganisationReducer.isWordingFetched;
}

export const getEnableVideoBlur = state => {
  return state.OrganisationReducer.customerData.enableVideoBlur;
}

export const getIsPreviewResize = state => {
  return state.OrganisationReducer.customerData.isPreviewResize;
}

export const getCustomBandwidthAUDIO_VIDEO = state => {
  return state.OrganisationReducer.customerData.customBandwidthAUDIO_VIDEO;
}

export const getCustomBandwidthSCREENSHARE = state => {
  return state.OrganisationReducer.customerData.customBandwidthSCREENSHARE;
}

export const getConsentMessage = state => {
  return state.OrganisationReducer.customerData.inbConsentMessage;
}

export const getIsCoBrowseContentShown = state => {
  return state.OrganisationReducer.customerData.inbShowCobrowseContent;
}

export const getIsMaskingEnabled = state => {
  return state.OrganisationReducer.customerData.inbIsMaskingEnabled;
}

export const getInbCSSelectors = state => {
  return state.OrganisationReducer.customerData.inbCSSelectors;
}

export const getUniversalLinks = state => {
  return state.OrganisationReducer.customerData.universalLinks;
}

export const getUniversalLinksEnabled = state => {
  return state.OrganisationReducer.customerData.universalLinksEnabled;
}

export const getSetTexts = state => {
  return state.OrganisationReducer.customerData.setTexts;
}

export const getSetTextEnabled = state => {
  return state.OrganisationReducer.customerData.setTextEnabled;
}